export const ASSESSMENT_PROTOCOL = Object.freeze({
  assessmentVersion: 2 as const,
  benchmarkItemCount: 12,
  maxMediaReplacements: 24,
  minimumHistoryVersion: 2 as const,
  sessionDurationMs: 30 * 60 * 1000,
  skillCheckItemCount: 8,
});
